import React from "react";
// import { useState, useRef, useEffect } from "react";


function LoveListChecker() {
  return (
    <>
      <section id="lovelistchecker">
        <div className="sun rotate linear infinite"></div>
        <div className="wrapper">
          <h2>Love List Checker</h2>
          <p>Drop your ETH wallet address to see if you’re on the Love List.</p>
          <p>Add the optional information to be notified of future releases.</p>
          <form action="#" method="post" id="loveList">
            <input
              type="text"
              name="ETH"
              autocomplete="off"
              id="ETH"
              placeholder="ETH Address"
              data-required
              data-error-message="please enter ETH Address"
            />
            <input
              type="text"
              name="Email"
              autocomplete="off"
              id="Email"
              placeholder="Email Address (optional)"
            />
            <input
              type="text"
              name="discord"
              autocomplete="off"
              id="discord"
              placeholder="Discord ID  (optional)"
            />
            <input
              type="text"
              name="twitter"
              autocomplete="off"
              id="twitter"
              placeholder="Twitter ID  (optional)"
            />
            <a className="twitter-share-button"
              href="https://twitter.com/intent/tweet?text=text%20will%20goes%20here&amp;&original_referer=https%3A%2D%2FAwww.healinghippies.io%2Flovelist&amp;url=https%3A%2F%2Fwww.healinghippies.io%2Flovelist&amp;&hashtags=healinghippies&via=HealingNFTs"
              data-size="large" target="_blank">
              <i></i>
              <span class="label" id="l">Tweet</span>
            </a>
            <button type="submit">Submit</button>
          </form>
        </div>
      </section>
    </>
  )
}

export default LoveListChecker




